import type { C1_FurnitureDefinition, C1_FurnitureRendererProps } from "../../types/C1_FurnitureTypes";
import { RoomType } from "../../types/C1_ModelTypes";
import { C1_FurnitureSvg } from "../C1_FurnitureSvg";
import { C1_FurnitureIcon } from "../C1_FurnitureIcon";

const DEFAULT_WIDTH = 0.4;
const DEFAULT_HEIGHT = 0.7;

const Toilet: C1_FurnitureDefinition = {
  id: "toilet",
  icon: <C1_FurnitureIcon kind="toilet" />,
  description: { en: "Toilet", de: "WC" },
  category: RoomType.Bathroom,
  defaultWidth: DEFAULT_WIDTH,
  defaultHeight: DEFAULT_HEIGHT,
  autoRotate: true,
  properties: [],
  Renderer: ({
    width,
    height,
    rotation,
    PX,
    strokeWidth,
    strokeColor,
    fillColor,
    showDetails,
  }: C1_FurnitureRendererProps) => {
    const finalRotation = rotation ?? 0;
    const finalStrokeWidth = strokeWidth ?? 2;
    const finalStrokeColor = strokeColor ?? "#000000";
    const finalFillColor = fillColor ?? "#ffffff";
    // Fit the original outline (20–80% of the width) to the full furniture width.
    const inset = Math.min(finalStrokeWidth, width / 2);
    const outlineWidth = Math.max(0, width - inset * 2);
    const x = (ratio: number) => inset + ((ratio - 0.2) / 0.6) * outlineWidth;

    return (
      <C1_FurnitureSvg
        PX={PX}
        width={width}
        height={height}
        rotation={finalRotation}
        viewBoxWidth={width}
        viewBoxHeight={height}
        originXPercentage={0}
        originYPercentage={0}
      >
        <rect
          x={x(0.225)}
          y={height * 0.036}
          width={outlineWidth * (0.55 / 0.6)}
          height={height * 0.255}
          rx={Math.min(0.05 * PX, width * 0.1, height * 0.1)}
          fill={finalFillColor}
          stroke={finalStrokeColor}
          strokeWidth={finalStrokeWidth * 2}
        />
        <path
          d={`M ${x(0.2)} ${height * 0.31} Q ${x(0.5)} ${height * 0.236} ${x(0.8)} ${height * 0.31} L ${x(0.725)} ${height * 0.855} Q ${x(0.5)} ${height * 0.964} ${x(0.275)} ${height * 0.855} Z`}
          fill={finalFillColor}
          stroke={finalStrokeColor}
          strokeWidth={finalStrokeWidth * 2}
        />
        {showDetails && (
          <ellipse
            cx={width / 2}
            cy={height * 0.59}
            rx={outlineWidth * (0.1625 / 0.6)}
            ry={height * 0.218}
            fill="none"
            stroke={finalStrokeColor}
            strokeWidth={finalStrokeWidth}
          />
        )}
      </C1_FurnitureSvg>
    );
  },
};

export default Toilet;
